var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0571 1.75C14.2478 1.74999 15.9685 1.74998 17.3119 1.93059C18.1832 2.04773 18.9405 2.24575 19.5967 2.59288C19.8513 2.72757 19.9786 2.79492 20.0042 2.93916C20.0298 3.0834 19.9244 3.2005 19.7136 3.43471L12.3848 11.5776C12.1863 11.7981 12.0871 11.9084 11.9582 11.9118C11.8293 11.9152 11.7244 11.8103 11.5146 11.6004L9.2071 9.2929C8.81658 8.90238 8.18341 8.90238 7.79289 9.2929C7.40236 9.68343 7.40236 10.3166 7.79289 10.7071L11.2928 14.2071C11.4868 14.4011 11.752 14.5069 12.0262 14.4997C12.3005 14.4925 12.5597 14.3729 12.7432 14.169L20.8648 5.14523C21.1349 4.84518 21.2699 4.69515 21.4404 4.73255C21.6109 4.76994 21.6665 4.94912 21.7778 5.30748C21.9096 5.73226 22.0026 6.19165 22.0694 6.68802C22.25 8.03144 22.25 9.75214 22.25 11.9428V12.0572C22.25 14.2479 22.25 15.9686 22.0694 17.312C21.8843 18.6886 21.4972 19.7809 20.639 20.6391C19.7808 21.4973 18.6886 21.8843 17.3119 22.0694C15.9685 22.25 14.2478 22.25 12.0571 22.25H11.9428C9.7521 22.25 8.03143 22.25 6.68802 22.0694C5.31136 21.8843 4.21911 21.4973 3.36091 20.6391C2.50271 19.7809 2.11568 18.6886 1.93059 17.312C1.74997 15.9686 1.74998 14.2479 1.75 12.0572V11.9428C1.74998 9.75213 1.74997 8.03144 1.93059 6.68802C2.11568 5.31137 2.50271 4.21911 3.36091 3.36091C4.21911 2.50272 5.31136 2.11568 6.68802 1.93059C8.03143 1.74998 9.75211 1.74999 11.9428 1.75H12.0571Z",
    fill: "url(#paint0_linear_5145_1299)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5145_1299",
    x1: 1.75024,
    y1: 1.75,
    x2: 18.7882,
    y2: 20.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28482"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.ed7b763fd96a82ab920dd7d55eae7947.svg";
export { ForwardRef as ReactComponent };